import { FunctionComponent } from 'react';

import { translate } from '@/i18n';
import { Pagination } from '@/table/types';
import './TablePageSize.scss';

const PAGE_SIZES = [5, 10, 25, 50, 100];

interface TablePageSizeProps extends Pagination {
  updatePageSize: (value: number) => void;
}

export const TablePageSize: FunctionComponent<TablePageSizeProps> = (props) => {
  if (props.resultCount <= 5) {
    return null;
  }
  return (
    <div className="d-flex align-items-center">
      <label className="text-muted text-nowrap fs-7">
        {translate('Rows per page')}:
      </label>
      <select
        className="form-select form-select-sm form-select-transparent ps-2 pe-5"
        aria-label={translate('Rows per page')}
        onChange={(event) => {
          props.updatePageSize(parseInt(event.target.value, 10));
        }}
        value={props.pageSize}
      >
        {PAGE_SIZES.map((option) => (
          <option value={option} key={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
};
